import React from 'react'

import { Formik } from 'formik'

import Yup from '_zari/validation/_yup'
import { ZariContext } from '_zari/context'
import { Portlet, Form, Row, Col, Button } from '_zari/core'

import * as TransferenciasService from 'services/transferencia.service'

import * as FormGroups from './formGroups'
import { DownloadAxiosFile } from 'utils'

export const ValidationSchema = Yup.object().shape({
  fechaDesde: Yup.string().required(),
  fechaHasta: Yup.string().required()
})

const PortletEstandar = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idSedeOrigen: '',
      fechaDesde: '',
      fechaHasta: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Descargando reporte de transferencias')

      TransferenciasService.descargarReporteEstandar(data)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Reporte transferencias estandar' />
      <Portlet.Body>
        <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
          {({ values, errors, touched, handleSubmit, isSubmitting }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroups.FechaDesdeFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.fechaDesde}
                    iTouched={touched.fechaDesde}
                  />
                  <FormGroups.FechaHastaFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.fechaHasta}
                    iTouched={touched.fechaHasta}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.IdSedeOrigenFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors._idSedeOrigen}
                    iTouched={touched._idSedeOrigen}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className='text-right'>
                  <Button onClick={handleSubmit} disabled={isSubmitting}>
                    Descargar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(PortletEstandar)
